import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'
import { configureStore as rtkConfigureStore } from '@reduxjs/toolkit'
import { clearRTKCacheMiddleware } from './middlewares/clear-rtk-cache.middleware'
import { configApi } from './apis/config.api'
import { rootReducer, type RootReducerState } from './rootReducer'
import { authApi } from './apis/auth.api'
import { tokenDistributionApi } from '../pages/TokenDistribution/services/tokenDistribution.api'

const config = {
  development: import.meta.env.DEV,
}

export const configureStore = (preloadedState?: Partial<RootReducerState>) => {
  const { development } = config

  const store = rtkConfigureStore({
    ...(preloadedState ? { preloadedState } : {}),
    reducer: rootReducer,
    devTools: development,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      })
        .concat(authApi.middleware)
        .concat(configApi.middleware)
        .concat(clearRTKCacheMiddleware)
        .concat(tokenDistributionApi.middleware),
    enhancers: (getDefaultEnhancers) =>
      getDefaultEnhancers({
        autoBatch: { type: 'timer', timeout: 1000 },
      }),
  })

  return store
}

// Get the type of our store variable
export type AppStore = ReturnType<typeof configureStore>
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = ThunkDispatch<RootState, unknown, UnknownAction>
